import { Stack, Paper, Button, Divider, Box, Alert } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import DynamicTable from "../DynamicTable/DynamicTable";
import CreateReceiptTop from "@components/molecules/CreateReceiptTop/CreateReceiptTop";
import MessageBar from "@components/atoms/MessageBar/MessageBar";
import { getCurrency } from "@utils/utils";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import ResumeItem from "@components/atoms/ResumeItem/ResumeItem";
import { IReceiptProductsUI } from "src/types/organisms";
import { grey } from "@mui/material/colors";
import ConfirmDialog from "@components/molecules/ConfirmDialog/ConfirmDialog";
import InputText from "@components/atoms/InputText/InputText";
const ReceiptProductsUI = ({
  headers,
  rows,
  pages,
  onChangePage,
  isLoading,
  receipt,
  products,
  setProducts,
  getTotalValue,
  onSubmit,
  showError,
  closeError,
  productError,
  closeProductError,
  onCancel,
  showEmployeeDialog,
  employeeCode,
  onEmployeeCodeChange,
  onConfirmSubmit,
  onCancelDialog,
  applicant,
  onApplicantChange,
  clientSummary
}: IReceiptProductsUI) => {
  const classes = {
    mainPaper: {
      width: 1,
      padding: "24px",
      height: "fit-content"
    },
    inputLabel: {
      color: grey[900],
      marginBottom: 0.5
    },
    transacPaper: {
      width: 400,
      padding: "24px",
      height: "fit-content"
    },
    switch: {
      margin: 0,
      display: "flex",
      justifyContent: "space-between"
    }
  };
  return <>
      <TitlePage title={"Agregar productos"} subtitle="Actualiza el recibo con nuevos productos" />
      <Stack direction={"row"} marginTop={3} spacing={3} alignItems={"flex-start"} width={1}>
        <DynamicTable title="Productos" subtitle="Agrega los productos necesarios para completar el recibo." headers={headers} rows={rows} pages={pages} onChangePage={onChangePage} emptyMessage="Aún no hay productos agregados" topRender={<CreateReceiptTop setProducts={setProducts} isLoading={isLoading ?? false} />} bottomRender={<MessageBar label="Total a pagar" value={getCurrency(getTotalValue())} />} />
        <Paper elevation={12} sx={classes.transacPaper}>
          <TitlePaper title="Resumen" />
          {clientSummary?.isOverCap && <Alert severity="warning" sx={{
          mb: 2
        }}>
              Cliente sobre cupo. Consumido:{" "}
              {getCurrency(clientSummary.consumedAmount)} / Cupo:{" "}
              {getCurrency(clientSummary.moneyCapAmount ?? 0)}
            </Alert>}
          <ResumeItem label="Productos" value={products.map(p => p.quantity).reduce((total, current) => total + Number(current), 0)} />
          <Divider sx={{
          mb: 1
        }} />
          <ResumeItem label="Saldo anterior" value={getCurrency(receipt.total)} />
          <ResumeItem label="Saldo agregado" value={getCurrency(getTotalValue())} />
          <MessageBar size="small" label="Total" value={getCurrency(receipt.total + getTotalValue())} />
          <Button fullWidth onClick={onSubmit} disabled={isLoading}>
            Agregar al recibo
          </Button>
          <Button fullWidth sx={{
          marginTop: 1
        }} color="secondary" onClick={onCancel} disabled={isLoading}>
            Cancelar
          </Button>
        </Paper>
      </Stack>
      <ErrorAlert open={productError} onClose={closeProductError} message={"Error, debes agregar por lo menos un producto"} duration={3000} />
      <ErrorAlert open={showError} onClose={closeError} message={"Lo sentimos, no se pudo agregar estos productos, intentalo nuevamente"} duration={3000} />
      <ConfirmDialog open={showEmployeeDialog} title="Confirmar productos" subtitle="Ingresa tu código de empleado *" message="Por favor, Ingresa tu código de empleado * para confirmar la adición de productos al recibo." cancelLabel="Cancelar" confirmLabel="Confirmar" cancelAction={onCancelDialog} confirmAction={onConfirmSubmit} contentRender={<Box marginTop={1}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={onEmployeeCodeChange} disabled={isLoading} sx={{
        mb: 2
      }} autoFocus={true} type="password" />
            <InputText label="Solicitante" name="applicant" placeholder="Ingresa el nombre del solicitante" register={onApplicantChange} disabled={isLoading} sx={{
        mb: 2
      }} />
          </Box>} disabled={!employeeCode.trim() || isLoading} withEnter={true} />
    </>;
};
export default ReceiptProductsUI;